module.exports = __webpack_public_path__ + "img/cinta3.921f1137.jpg";